import { useEffect, useState, Fragment } from 'react';
import Logo from './Logo';
import { FormattedMessage } from 'react-intl';
import iconHome from '../../icons/start-menu.svg';
import iconFinger from '../../icons/finger-menu.svg';
import iconClients from '../../icons/clients-menu.svg';
import iconContracts from '../../icons/document-menu.svg';
import iconSettlements from '../../icons/settlements-menu.svg';
import iconResources from '../../icons/icon_marketing_materials.svg';
import iconIntegrations from '../../icons/icon_integrations_new.svg';
import iconMarketingResources from '../../icons/marketing-menu.svg';
import MenuElement from './MenuElement';
import SalesmanModal from '../Modal/SalesmanModal';
import DesktopTopMenu from './DesktopTopMenu';
import MobileTopMenu from './MobileTopMenu';
import MediaQuery from 'react-responsive';
import FreshWorksHookModal from '../Modal/FreshWorksHookModal';
import { showModalLogic } from '../../services/freshWorksLogic';
import SubMenuComponent from './SubMenuComponent';
import { resetSubMenu } from '../../reducers/subMenuActions';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserInfo } from '../../store/selectors';
import { selectMenu } from '../../store/selectors/menu';
import { COMPLETED } from '../../store/actions/types';
import { selectBrokerProducts } from '../../store/selectors/brokerProducts';

const Header = ({ currentSettlement }) => {
  const dispatch = useDispatch();
  const { data, status } = useSelector(selectUserInfo);
  const { subMenuPathActive } = useSelector(selectMenu);
  const [hasRecommendationCode, setHasRecommendationCode] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [showFreshModal, setShowFreshModal] = useState(false);
  const brokerProducts = useSelector(selectBrokerProducts);
  const isBrokerProductsCompleted = brokerProducts.status === COMPLETED;

  const isMarketingMaterialsVisible =
    (brokerProducts?.data?.length !== 1 && brokerProducts?.data?.filter((item) => item.name !== 'PRAGMA_PAY')) ||
    (brokerProducts?.data?.length === 1 && brokerProducts?.data?.filter((item) => item.name !== 'PRAGMA_PAY').length !== 0);

  const handleCloseFreshModal = () => {
    showModalLogic(true);
    setShowModal(true);
  };

  const handleOpenModal = () => setShowModal(true);

  const handleCloseModal = () => setShowModal(false);

  const resetOnMouseOut = subMenuPathActive !== null ? () => dispatch(resetSubMenu()) : () => {};

  useEffect(
    () => (data?.recommendationCode ? setHasRecommendationCode(true) : undefined),
    [status === COMPLETED && data?.recommendationCode !== undefined]
  );

  return (
    <header>
      <div className='top-bar'>
        <div className='section'>
          <Logo />
          <MediaQuery maxWidth={767}>
            <MobileTopMenu handleOpenModal={handleOpenModal} />
          </MediaQuery>
          <MediaQuery minWidth={768}>
            <DesktopTopMenu handleOpenModal={handleOpenModal} />
          </MediaQuery>
        </div>
      </div>
      <div className='menu-wrapper' onMouseLeave={resetOnMouseOut}>
        <div className='menu'>
          <div className='section'>
            <ul className='links'>
              <MenuElement to='/' separator>
                <img className='menu-icon' src={iconHome} alt='' />
                <span>
                  <FormattedMessage id='Homepage' />
                </span>
              </MenuElement>
              <MenuElement to='/lead-block' separator>
                <img className='menu-icon' src={iconFinger} alt='' />
                <span>
                  <MediaQuery maxWidth={767}>
                    <FormattedMessage id='Block...' />
                  </MediaQuery>
                  <MediaQuery minWidth={768}>
                    <FormattedMessage id='Block lead' />
                  </MediaQuery>
                </span>
              </MenuElement>
              <MenuElement to='/lead-list' separator>
                <img className='menu-icon' src={iconClients} alt='' />
                <span>
                  <FormattedMessage id='Leads' />
                </span>
              </MenuElement>
              <MenuElement to='/proposal-contract-list' separator>
                <img className='menu-icon' src={iconContracts} alt='' />
                <span>
                  <MediaQuery maxWidth={767}>
                    <FormattedMessage id='Contracts...' />
                  </MediaQuery>
                  <MediaQuery minWidth={768}>
                    <FormattedMessage id='Contracts and proposals' />
                  </MediaQuery>
                </span>
              </MenuElement>
              <MenuElement to={['/invoice-loan-list', '/invoice-loan-gained-list', '/loan-update-list']} subElements>
                <img className='menu-icon' src={iconContracts} alt='' />
                <span>
                  <MediaQuery maxWidth={767}>
                    <FormattedMessage id='Invoices...' />
                  </MediaQuery>
                  <MediaQuery minWidth={768}>
                    <FormattedMessage id='Invoices and loans' />
                  </MediaQuery>
                </span>
              </MenuElement>
              <MenuElement to='/settlements' separator>
                <img className='menu-icon' src={iconSettlements} alt='' />
                <span className={currentSettlement?.data ? 'highlighted' : ''}>
                  <FormattedMessage id='Settlements' />
                </span>
              </MenuElement>
              {hasRecommendationCode ? (
                <Fragment>
                  <MenuElement to={'/integrations'}>
                    <img className='menu-icon' src={iconIntegrations} alt='' />
                    <span>
                      <MediaQuery maxWidth={767}>
                        <FormattedMessage id='Integrations...' />
                      </MediaQuery>
                      <MediaQuery minWidth={768}>
                        <FormattedMessage id='Integrations' />
                      </MediaQuery>
                    </span>
                  </MenuElement>
                  {isMarketingMaterialsVisible && isBrokerProductsCompleted ? (
                    <MenuElement to={'/integration-resources'}>
                      <img className='menu-icon' src={iconResources} alt='' />
                      <span>
                        <MediaQuery maxWidth={767}>
                          <FormattedMessage id='integration-resources-label...' />
                        </MediaQuery>
                        <MediaQuery minWidth={768}>
                          <FormattedMessage id='integration-resources-label' />
                        </MediaQuery>
                      </span>
                    </MenuElement>
                  ) : null}
                </Fragment>
              ) : null}
              <MenuElement to='/marketing-resources' separator>
                <img className='menu-icon' src={iconMarketingResources} alt='' />
                <span>
                  <MediaQuery maxWidth={767}>
                    <FormattedMessage id='Marketing mat...' />
                  </MediaQuery>
                  <MediaQuery minWidth={768}>
                    <FormattedMessage id='Marketing materials' />
                  </MediaQuery>
                </span>
              </MenuElement>
            </ul>
          </div>
        </div>
        <SubMenuComponent />
      </div>
      <SalesmanModal isOpen={showModal} onRequestClose={handleCloseModal} />
      <FreshWorksHookModal isOpen={showFreshModal} onRequestClose={handleCloseFreshModal} />
    </header>
  );
};

export default Header;
